import { useQuery } from '@tanstack/react-query'
import { getCSRFToken } from 'api/authApi'

const useCSRFToken = () =>
  useQuery(['csrf-token'], getCSRFToken, { staleTime: Infinity })

export { useCSRFToken }
